<template>
    <div v-if="content" ref="countryInfo" class="country-info">
        <div @click="toggle()" class="align-center justify-between pointer">
            <div class="align-center">
                <icon name="fill-info" width="20px" height="20px" fill="var(--yellow-color)"/>
                <h4 class="ml-6">{{ localizeList.countryAnnotationUpper }}</h4>
            </div>

            <icon name="angle" :style="{'transform': `rotate(${showContent ? 180 : 0}deg)`}"
                  class="angle-icon"
                  width="16px" height="12px" fill="var(--lighten-5-color)"/>
        </div>
        <div :id="`country-content${componentId}`"
             v-show="showContent"
             :class="['content', {'open': showAllContent}]">
            <p v-html="content" class="mt-6"></p>
            <span v-if="showAllContent && contentMore"
                  @click="toggleAllContent(false)"
                  class="close pb-8">{{ localizeList.minimize }}</span>
        </div>
        <span v-show="!showAllContent && contentMore"
              @click="toggleAllContent(true)"
              class="more">{{ localizeList.moreUpper }}</span>
    </div>
</template>

<script>
    import {bus} from "../../../main";

    export default {
        name: "CountryInfo",
        data() {
            return {
                content: "",
                showAllContent: false,
                showContent: true,
                contentMore: false,
                componentId: this._uid
            }
        },
        computed: {
            getWindowSettings() {
            return window.settings;
           },
            countryKey() {
                if (!this.$route.fullPath) return null;

                return this.$route.fullPath
                    ?.split("&")
                    ?.find(x => x.includes("destination="))
                    ?.split("=")[1]
                    ?.split("_")[1]
            }
        },
        created() {
            bus.$on("countryInfo_showAllContent", val => {
                this.showAllContent = val;
            });
            bus.$on("countryInfo_showContent", val => {
                this.showContent = val;
            });
            bus.$on("countryInfo_showContentMore", val => {
                this.contentMore = val;
            });
        },
        mounted() {
            this.getCountryInfo();

            const showCountryInfo = JSON.parse(sessionStorage.getItem("showCountryInfo"));
            if (!this.getWindowSettings.hideCountryInfo) {
              this.showContent = showCountryInfo === null || showCountryInfo;
            } else {
              this.showContent = !this.getWindowSettings.hideCountryInfo
            }
        },
        methods: {
            toggle() {
                this.showContent = !this.showContent;
                sessionStorage.setItem("showCountryInfo", this.showContent);
                bus.$emit("countryInfo_showContent", this.showContent);
            },
            toggleAllContent(val) {
                this.showAllContent = val;
                bus.$emit("countryInfo_showAllContent", this.showAllContent);
            },
            getCountryInfo() {
                if (!this.countryKey) return;
                this.toggleAllContent(false);

                this.$store.dispatch("tour/A_GET_COUNTRY_INFO", this.countryKey)
                    .then(res => {
                        this.content = res;
                        bus.$emit("country-info", res);

                        setTimeout(() => {
                            const contentElem = document.getElementById(`country-content${this.componentId}`);
                            if (contentElem?.scrollHeight) {
                                this.contentMore = contentElem.scrollHeight > contentElem.clientHeight;
                                bus.$emit("countryInfo_showContentMore", this.contentMore);
                            }
                        },0)
                    })
            }
        },
        watch: {
            countryKey(val) {
                if (val !== null) this.getCountryInfo();
            },
        }
    }
</script>

<style scoped>
    .country-info {
        position: relative;
        padding: 4px 24px;
        background-color: var(--white-color);
        border-radius: 6px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        /*margin-bottom: 18px;*/
        /*margin: 0 47px 18px;*/
        margin: 0 auto 18px;
        overflow: hidden;
        z-index: 1;
    }

    h4 {
        font-weight: 500;
        font-size: 16px;
        line-height: 29px;
        color: #1D1D1D;
    }

    .content {
        font-size: 15px;
        line-height: 19px;
        color: #1D1D1D;
        overflow: hidden;
        max-height: 70px;
        word-break: break-all;
    }
    .content.open {
        max-height: none;
    }

    .more {
        position: absolute;
        top: 84px;
        right: 24px;
        background-color: var(--white-color);
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        text-decoration-line: underline;
        color: var(--primary-color);
        padding-left: 10px;
        cursor: pointer;
    }

    .close {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary-color);
        line-height: 18px;
        cursor: pointer;
        text-decoration-line: underline;
    }

    .angle-icon {
        transition: all .2s;
    }

</style>